import React, { createContext, useState } from 'react'
import { Box, Typography, Tabs, Tab, Paper, Stack, Chip, Divider } from '@mui/material'
import SensorsIcon from '@mui/icons-material/Sensors'
import ReportProblemIcon from '@mui/icons-material/ReportProblem'
import NotesIcon from '@mui/icons-material/Notes'
import EventIcon from '@mui/icons-material/Event'
import UpcomingEvents from './UpcomingEvents'
import ControlRoomHoursNotice from '../../../../components/Subscriptions/ControlRoomHoursNotice'
import ActiveControlRooms from './ActiveControlRooms'
import OpenIncidents from './OpenIncidents'
import RecentLogs from './RecentLogs'
import { BedroomChild } from '@mui/icons-material'
import BedManager from './BedManager/BedManager'
import AddCustomControlRoom from './AddCustomControlRoom'

export const EventControlDashboardContext = createContext({})

export default function EventControlDashboard() {
  const [tab, setTab] = useState(0)

  const tabs = [
    { label: 'Control Rooms', icon: <SensorsIcon fontSize="small" /> },
    { label: 'Bed Management', icon: <BedroomChild fontSize="small" /> },
    { label: 'Open Incidents', icon: <ReportProblemIcon fontSize="small" /> },
    { label: 'Recent Logs', icon: <NotesIcon fontSize="small" /> },
    { label: 'Custom Control Room', icon: <EventIcon fontSize="small" /> },
  ]

  return (
    <EventControlDashboardContext.Provider value={{ tab }}>
      <Box
        sx={{
          p: 2,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            borderRadius: 5,
            overflow: 'hidden',
            border: '1px solid #E2E8F0',
            boxShadow: '0 18px 60px rgba(36,47,64,0.12)',
          }}
        >
          <Box
            sx={{
              p: { xs: 3, md: 4 },
              color: 'white',
              background:
                'linear-gradient(135deg, #1A2230 0%, #242F40 52%, #239AA4 150%)',
            }}
          >
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              justifyContent="space-between"
              alignItems={{ xs: 'flex-start', md: 'center' }}
              spacing={2}
            >
              <Stack spacing={0.75}>
                <Typography variant="overline" sx={{ opacity: 0.72 }}>
                  Command & Control
                </Typography>

                <Typography variant="h4" fontWeight={900} color="white">
                  Event Control Dashboard
                </Typography>

                <Typography
                  variant="body2"
                  sx={{ color: 'rgba(255,255,255,0.78)', maxWidth: 720 }}
                >
                  Monitor active control rooms, incidents, logs and upcoming
                  events from one operational overview.
                </Typography>
              </Stack>

              <Chip
                label="Operational View"
                sx={{
                  backgroundColor: 'rgba(255,255,255,0.12)',
                  color: 'white',
                  border: '1px solid rgba(255,255,255,0.22)',
                  fontWeight: 700,
                }}
              />
            </Stack>
          </Box>

          <Box sx={{ px: { xs: 2, md: 3 }, pt: 2 }}>
            <Tabs
              value={tab}
              onChange={(e, newValue) => setTab(newValue)}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                minHeight: 56,
                '& .MuiTab-root': {
                  textTransform: 'none',
                  fontWeight: 800,
                  minHeight: 56,
                  borderRadius: 3,
                  mr: 1,
                  color: '#64748B',
                },
                '& .Mui-selected': {
                  color: '#239AA4 !important',
                  backgroundColor: '#E6F7F9',
                },
                '& .MuiTabs-indicator': {
                  display: 'none',
                },
              }}
            >
              {tabs.map((item) => (
                <Tab
                  key={item.label}
                  icon={item.icon}
                  iconPosition="start"
                  label={item.label}
                />
              ))}
            </Tabs>
          </Box>

          <Box sx={{ p: { xs: 2, md: 3 } }}>
            <ControlRoomHoursNotice sx={{ mb: 2 }} />
            {tab === 0 && (
              <Stack gap={3}>
                <ActiveControlRooms />
                <Divider />
                <UpcomingEvents />
              </Stack>
            )}
            {tab === 1 && <BedManager />}
            {tab === 2 && <OpenIncidents />}
            {tab === 3 && <RecentLogs />}
            {tab === 4 && <AddCustomControlRoom />}
          </Box>
        </Paper>
      </Box>
    </EventControlDashboardContext.Provider>
  )
}
